<template>
  <game-loading-ssm
    v-if="show"
    background-file="loading-archery.jpg"
    :game-version="version"
  />
</template>

<script lang="ts">
import { GameLoadingSsm } from '@powerplay/core-minigames-ui-ssm'

import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingComponent',
  components: { GameLoadingSsm },
  data() {

    return {
      show: true
    }

  },
  computed: {
    version() {

      return document.getElementById('live-layout')?.getAttribute('data-version') ?? ''

    }
  }
})

</script>
